export const COMMENTS_LOADED = "comments/loaded"
export const COMMENTS_ADDED = "comments/added"
export const COMMENT_UPDATED = "comments/commentUpdated"
export const COMMENTS_DELETED = "comments/commentsDeleted"